import { type JSX } from 'react';

import type { FieldDef } from '../types';

// A required field's label carries the same red asterisk as the shared Label's
// `required` variant. It's hidden from screen readers, which hear
// `aria-required` on the control instead of "star".
const fieldLabel = (field: FieldDef): string | JSX.Element => {
  const text = field.label || field.key;
  if (!field.required) return text;
  return (
    <>
      {text}
      <span aria-hidden="true" className="ml-0.5 text-red-500 dark:text-red-400">
        *
      </span>
    </>
  );
};

export default fieldLabel;
